import {
    ToastIcons,
    Root as ToastRoot,
    Title as ToastTitle,
    ToastVariant,
    Spinner,
  } from '../styles/toast.style'

/*  Toasts display brief, temporary notifications.
    Only used for:
      - confirmations
      - simple notifications
      - low-priority alerts
    They are noticeable, do not disrupt the user experience and do not require an action to be taken.
    Usage Guide: https://spectrum.adobe.com/page/toast/   */

export interface ToastProps {
  id?: string
  variant: ToastVariant
  title: string
  duration?: number
}

export const Toast = ({ variant, title, duration }: ToastProps) => {
  const ToastIcon = ToastIcons[variant]
  return (
    <ToastRoot color={variant} duration={duration ?? (variant === 'loading' ? 60000 : 5000)}>
      {ToastIcon ? <ToastIcon size={24} /> : <Spinner />}
      <ToastTitle>{title}</ToastTitle>
    </ToastRoot>
  )
}
